import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import SVG from "react-inlinesvg";
import Cookies from "universal-cookie";
import classnames from "classnames";
import { FILTER_MODIFIERS } from "../../../src/shared/constants";
import { Textarea } from "src/sudokit/components/Textarea";
import { Spinner } from "src/sudokit/components/Spinner";
import HStack from "src/sudokit/Layout/HStack";
import StickyNoteAnchor from "../components/StickyTour/StickyNoteAnchor";
import { useStickyTourStore } from "../stores/stickyTourStore";
import { AnchorIds, TourSignal } from "../components/StickyTour/TourTypes";

const cookies = new Cookies();

// Select related styles:
const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "16px",
  // color:"var(--grey-0)"
};
const themeFunction = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    neutral0: "var(--menu-color)",
    neutral30: "var(--grey-0)",
    neutral20: "var(--grey-0)",
    primary: "var(--primary-cta)",
    primary25: "var(--menu-color-hover)",
    primary50: "var(--menu-color-active)",
  },
});
const plainOptionLabel = (data) => <div style={groupStyles}>{data.label}</div>;
const styleObject = {
  control: (base) => ({
    ...base,
    border: "1.5px solid var(--grey-0)",
    display: "flex",
    borderRadius: "5px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--grey-0)",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    // width:'20px',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  option: (base, state) => ({
    ...base,
    color: state.isSelected ? "white" : "var(--grey-0)",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "10px",
    overflow: "hidden",
    paddingTop: "0px",
    boxShadow: "var(--default-drop-shadow)",
  }),
  menuList: (base) => ({
    ...base,
    paddingTop: "0px",
    paddingBottom: "0px",
  }),
};
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <SVG src="/assets/settings_dropdown_icon.svg" />
    </components.DropdownIndicator>
  );
};

export default function RewriteInput(props) {
  const [modifier, setModifier] = useState(FILTER_MODIFIERS[0]);
  const [error, setError] = useState(null);
  const [custom, setCustom] = useState(false);
  const [customModifier, setCustomModifier] = useState("");
  const sendFlowSignal = useStickyTourStore((state) => state.sendFlowSignal);
  // Set the initial value of modifier and custom states
  useEffect(() => {
    if (!props.modifier) {
      return;
    } else {
      let found = FILTER_MODIFIERS.find((m) => {
        return m.value == props.modifier;
      });
      if (found) {
        setModifier(found);
      } else {
        setModifier({ value: "custom", label: "Custom" });
        setCustom(true);
        setCustomModifier(props.modifier);
      }
    }
  }, [props.modifier]);

  function submit(e) {
    if (e) {
      e.preventDefault();
    }

    let theModifier = custom ? customModifier : modifier.value;

    if (!theModifier || theModifier.length < 5) {
      return setError("C'mon, you're a writer. Give us more than that!");
    } else {
      setError(null);
    }

    sendFlowSignal(TourSignal.REWRITE_GO_CLICKED);
    const selection = props.getSelection();

    // User has changed the selection in the editor so we assume that they want to
    // filter for that new selection when they hit the Go button

    if (selection.length !== 0 && selection.text !== props.prompt) {
      if (props.numberCards > 0) {
        // If we already streamed at least one card, then we intiate a whole new card set with the new selection and with the current modifier
        console.log("intiate new filter cardset");
        props.initiateNewFilter(theModifier);
        return;
      } else {
        // If we never streamed, then we set the prompt to be the new selection and go ahead and stream based on this selection into this card set
        props.setPrompt(selection.text);
      }
    }

    cookies.set("needsFilterHighlight", "no");

    props.submit(theModifier);
  }

  function changeModifier(selected) {
    setCustom(selected.value === "custom");
    setModifier(selected);
    cookies.set("needsFilterHighlight", "no");
  }

  function changeCustom(e) {
    e.preventDefault();
    setCustomModifier(e.target.value);
  }

  let highlight = cookies.get("needsFilterHighlight") === undefined;

  return (
    <form
      className={classnames("rewrite-input", { highlight: highlight })}
      onSubmit={submit}
    >
      <StickyNoteAnchor anchorId={AnchorIds.REWRITE_MENU_DROPDOWN} />
      <section className='flex flex-row items-center gap-2'>
        <div className="select-modifier">
          <Select
            formatOptionLabel={plainOptionLabel}
            styles={styleObject}
            theme={themeFunction}
            components={{ DropdownIndicator }}
            // isDisabled={props.disabled}
            value={modifier}
            onChange={changeModifier}
            options={FILTER_MODIFIERS}
            className={classnames("select-modifier-component", { custom: custom })}
          />
        </div>

        {custom && (
          <div className="custom-rewrite-form">
            <div>
              <p>Rewrite to...</p>
            </div>
            {/* <div className="custom"> */}
            <HStack>
              <Textarea
                className="min-h-[44px]"
                maxLength="500"
                type="text"
                onChange={changeCustom}
                value={customModifier}
                minRows={1}
                placeholder="be more quirky"
              />
              {props.disabled && <Spinner size="lg" />}
              {!props.disabled && <button disabled={props.disabled}>Go!</button>}
            </HStack>
            {/* </div> */}
          </div>
        )}
        {!custom && (
          <div>
            {props.disabled && <Spinner size="lg" />}
            {!props.disabled && (
              <button
                className="inline-button"
                disabled={props.disabled}
              >
                Go!
              </button>
            )}
          </div>
        )}
        {error && <div className="error">{error}</div>}
      </section>
    </form>
  );
}
